module.exports = __webpack_public_path__ + "static/media/testimony1.9b6097b3.jpg";